import { httpsCallable, Functions } from "firebase/functions";
import { getRemoteEnv } from '../config/remoteEnv';

export const httpsCallableWithAppId = (functions: Functions, functionName: string) => {
  const callable = httpsCallable(functions, functionName);
  return (data = {}) => {
    if (getRemoteEnv().appId) {
      return callable({
        appId: getRemoteEnv().appId,
        ...data
      });
    } else {
      console.log('appId not found');
      return callable(data);
    }
  };
};